var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiCoracoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 12,
    viewBox: "0 0 35 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7673 2.54014C13.169 -1.70534 7.9745 0.192637 7.5 2.31538C6.85069 0.0677699 1.78109 -1.60545 0.232733 2.54014C-1.49043 7.16022 6.90064 11.3058 7.5 11.9801C8.09936 11.4307 16.4904 7.0853 14.7673 2.54014Z",
    fill: "#5AB2AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7673 2.54014C33.169 -1.70534 27.9745 0.192637 27.5 2.31538C26.8507 0.0677699 21.7811 -1.60545 20.2327 2.54014C18.5096 7.16022 26.9006 11.3058 27.5 11.9801C28.0994 11.4307 36.4904 7.0853 34.7673 2.54014Z",
    fill: "#EFA73F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiCoracoes);
export default __webpack_public_path__ + "static/media/EmojiCoracoes.7de93acaf4c1066bc3a1b1c0c42c0d2c.svg";
export { ForwardRef as ReactComponent };